var components
try {
  components = {
    uniLoadMore: function () {
      return import(
        /* webpackChunkName: "components/uni-load-more/uni-load-more" */ "@/components/uni-load-more/uni-load-more.vue"
      )
    },
    neilModal: function () {
      return import(
        /* webpackChunkName: "components/neil-modal/neil-modal" */ "@/components/neil-modal/neil-modal.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var l2 = _vm.__map(_vm.navList, function (tabItem, tabIndex) {
    var $orig = _vm.__get_orig(tabItem)
    var g0 = tabItem.loaded === true && tabItem.orderList.length === 0
    var l1 = _vm.__map(tabItem.orderList, function (item, index) {
      var $orig = _vm.__get_orig(item)
      var f0 = _vm._f("dateFormat")(item.gmtCreate)
      var g1 = item.skuList.length
      var l0 =
        g1 > 1
          ? _vm.__map(item.skuList, function (skuItem, skuIndex) {
              var $orig = _vm.__get_orig(skuItem)
              var m0 = _vm.style(200)
              return {
                $orig: $orig,
                m0: m0,
              }
            })
          : null
      var g2 = item.skuList.length
      var m1 = _vm.style(200)
      return {
        $orig: $orig,
        f0: f0,
        g1: g1,
        l0: l0,
        g2: g2,
        m1: m1,
      }
    })
    return {
      $orig: $orig,
      g0: g0,
      l1: l1,
    }
  })
  if (!_vm._isMounted) {
    _vm.e0 = function ($event) {
      _vm.refundShow = false
    }
    _vm.e1 = function ($event) {
      _vm.refundShow = false
    }
  }
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        l2: l2,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }